import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    articuloTipoId: 0,
    articuloTipo: null,
    articuloTipoNombre: null,
    proveedorId: 0,
    proveedor: null,
    proveedorNombre: null,
    monedaId: 0,
    moneda: null,
    monedaNombre: null,
    cantidad: 0,
    costo: 0,
    costoTotal: 0,
    costoUnitario: false,
    diasProduccion: 0,
    rowVersion: null,

    /* Datos de la orden al proveedor */
    fechaComprobante: moment(new Date()).format('YYYY-MM-DD'),
    fechaEntrega: moment(new Date()).format('YYYY-MM-DD'),
    direccionEntrega: '',
    observaciones: '',
    formasPago: [],

    noRequiereContrato: false,
    tieneContrato: false,
    contratoPagare: false,

    ordenTrabajoInterna: {},
    ordenTrabajoInternaDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR' (state) {
        state.id = 0;
        state.articuloTipoId = 0;
        state.articuloTipo = null;
        state.articuloTipoNombre = null;
        state.proveedorId = 0;
        state.proveedor = null;
        state.proveedorNombre = null;
        // state.monedaId = 0;
        // state.moneda = null;
        // state.monedaNombre = null;
        state.monedaId = 101;
        state.moneda = {
            id: 101,
            nombre: 'PESOS'
        };
        state.monedaNombre = 'PESOS';
        state.cantidad = 0;
        state.costo = 0;
        state.costoTotal = 0;
        state.costoUnitario = false;
        state.diasProduccion = 0;
        state.observaciones = '';
        state.rowVersion = null;

        state.fechaComprobante = moment(new Date()).format('YYYY-MM-DD'),
        state.fechaEntrega = moment(new Date()).format('YYYY-MM-DD'),
        state.direccionEntrega = '';
        state.observaciones = '';
        // state.renglones = [];
        state.formasPago = [];

        state.noRequiereContrato = false;
        state.tieneContrato = false;
        state.contratoPagare = false;

    },
    'SET_ARTICULO_TIPO'(state, articuloTipo) {
        state.articuloTipoId = articuloTipo? articuloTipo.id : 0;
        state.articuloTipo = articuloTipo;
        state.articuloTipoNombre = articuloTipo? articuloTipo.nombre.trim() : null;
        state.observaciones = articuloTipo? articuloTipo.descripcion.trim() : '';
    },
    'INICIALIZAR_PROVEEDOR'(state) {
        state.proveedorId = 0;
        state.proveedor = null;
        state.proveedorNombre = null;

        state.noRequiereContrato = false;
        state.tieneContrato = false;
        state.contratoPagare = false;

        state.formasPago = [];
    },
    'SET_PROVEEDOR'(state, proveedor) {
        state.proveedorId = proveedor? proveedor.id : 0;
        state.proveedor = proveedor;
        state.proveedorNombre = proveedor? proveedor.nombre.trim() : null;

        state.noRequiereContrato = proveedor.noRequiereContrato;
        state.tieneContrato = proveedor.tieneContrato;
        state.contratoPagare = proveedor.contratoPagare;

        if (proveedor.formaPagoId != 0) {
            let addFormaPago = true;
            if (state.formasPago) {
                if (state.formasPago.length != 0) {
                    addFormaPago = false;
                }
            }
            if (addFormaPago) {
                state.formasPago.push({
                    formaPagoId: proveedor.formaPagoId,
                    formaPago: proveedor.formaPago.nombre.trim(),
                    porcentaje: parseFloat(100),
                    condiciones: '',
                })
            }
        }
    },
    'SET_MONEDA'(state, moneda) {
        state.moneda = moneda;
        if (moneda) {
            state.monedaId = moneda.id? moneda.id : 0;
            state.monedaNombre = moneda.nombre? moneda.nombre.trim() : null;
        } else {
            state.monedaId = 0;
            state.monedaNombre = null;
        }
    },
    'CALCULAR_COSTO_UNITARIO'(state) {
        if (state.cantidad != 0) {
            state.costo = roundToTwo(state.costoTotal / state.cantidad);
        } else {
            state.costo = 0;
        }
    },
    'CALCULAR_COSTO_TOTAL'(state) {
        state.costoTotal = roundToTwo(state.costo * state.cantidad);
    },
    'ADD_FORMA_PAGO'(state, formaPago) {
        state.formasPago.push({
            formaPagoId: formaPago.formaPagoId,
            formaPago: formaPago.formaPago.nombre.trim(),
            porcentaje: formaPago.porcentaje,
            condiciones: formaPago.condiciones.trim(),
        })
    },
    'REMOVE_FORMA_PAGO'(state, formaPago) {
        let key = state.formasPago.findIndex(fp => fp == formaPago);
        if (key != -1) {
            state.formasPago.splice(key, 1);
        }
    },

    'INICIALIZAR_DATOS' (state) {
        state.ordenTrabajoInterna = {};
        state.ordenTrabajoInternaDatos = [];
    },
    'SET_ORDEN_DATOS' (state, params) {
        state.ordenTrabajoInterna = params.ordenTrabajoInterna;
        state.ordenTrabajoInternaDatos = params.ordenTrabajoInternaDatos;
    },
};

function roundToTwo(num) {    
    return +(Math.round(num + "e+2")  + "e-2");
}

const getters = {
    getField,

    ordenTrabajoInterna(state) {
        return state.ordenTrabajoInterna;
    },

    ordenTrabajoInternaDatos(state) {
        return state.ordenTrabajoInternaDatos;
    },
};

const actions = {
    inicializar ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR');
            resolve();
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMsj = '';

            let formasPago = [];
            let porcentajeTotal = 0;
            if (state.formasPago) {
                state.formasPago.forEach(formaPago => {
                    formasPago.push({
                        formaPagoId: formaPago.formaPagoId,
                        porcentaje: formaPago.porcentaje,
                        condiciones: formaPago.condiciones.trim()
                    })
                    porcentajeTotal += formaPago.porcentaje;
                });
            }
            // if (porcentajeTotal != 0 & porcentajeTotal != 100) {
            if (formasPago.length == 0) {
                save = false;
                errorMsj = 'Debe seleccionar la forma de pago correspondiente.';
            } else if (porcentajeTotal != 100) {
                save = false;
                errorMsj = 'El porcentaje total correspondiente a las formas de pago seleccionadas debe ser igual a 100.';
            }

            let ordenTrabajo = {
                articuloTipoId: parseInt(state.articuloTipoId),
                cantidad: parseInt(state.cantidad),
                diasProduccion: parseInt(state.diasProduccion),
                observaciones: state.observaciones.trim(),
            };

            let renglones = [];
            renglones.push({
                ordenTrabajoInternaId: 0,
                cantidad: state.cantidad,
                importe: state.costo,
                importeTotal: state.costoTotal,
                precioUnitario: state.costoUnitario                
            })

            let ordenProveedor= {
                fechaComprobante: moment(state.fechaComprobante).format('YYYY-MM-DD'),
                fechaEntrega: moment(state.fechaEntrega).format('YYYY-MM-DD'),
                proveedorId: parseInt(state.proveedorId),
                monedaId: parseInt(state.monedaId),
                direccionEntrega: state.direccionEntrega.trim().toUpperCase(),
                observaciones: state.observaciones.trim(),
                formasPago,
                renglones
            };

            let ordenTrabajoInterna = {
                ordenTrabajoInterna: ordenTrabajo,
                ordenProveedor
            }

            let url = 'ordenesproveedores/orden-interna';
            
            if (save) {
                apiAxios.post(url, ordenTrabajoInterna)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMsj);
            }
        })
    },
    setProveedor: ( {commit }, proveedor) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_PROVEEDOR');

            let getDatosProveedor = false;

            if (proveedor) {
                if (proveedor.id) {
                    if (proveedor.id != 0) {
                        getDatosProveedor = true;
                    }
                }
            }
            if (getDatosProveedor) {
                apiAxios.get('proveedores/' + proveedor.id + '/ordenes') 
                    .then(res => {
                        proveedor.noRequiereContrato = res.data.noRequiereContrato;
                        proveedor.tieneContrato = res.data.tieneContrato;
                        proveedor.contratoPagare = res.data.contratoPagare;
                        proveedor.formaPagoId = res.data.formaPagoId;
                        proveedor.formaPago = res.data.formaPago;
                
                        commit('SET_PROVEEDOR', proveedor);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
            
            // commit('SET_PROVEEDOR', proveedor);
            // resolve();
        })
    },
    setArticuloTipo: ( { commit }, articuloTipoId) => {
        return new Promise((resolve, reject) => {
            apiAxios.get('articulostipos/' + articuloTipoId ) 
            .then(res => {
                commit('SET_ARTICULO_TIPO', res.data);
                resolve();
            })
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setMoneda: ( { commit }, moneda) => {
        return new Promise((resolve, reject) => {
            commit('SET_MONEDA', moneda);
            resolve();
        })
    },
    calcularCostoUnitario: ( { commit }) => {
        return new Promise((resolve, reject) => {
            commit('CALCULAR_COSTO_UNITARIO');
            resolve();
        }, error => {
            reject(error);
        })
    },
    calcularCostoTotal: ( { commit }) => {
        return new Promise((resolve, reject) => {
            commit('CALCULAR_COSTO_TOTAL');
            resolve();
        }, error => {
            reject(error);
        })
    },
    addFormaPago ( { commit }, formaPago ) {
        commit('ADD_FORMA_PAGO', formaPago);
    },
    removeFormaPago ( { commit }, formaPago ) {
        commit('REMOVE_FORMA_PAGO', formaPago);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}